import { render, staticRenderFns } from "./JsmRecaptcha.vue?vue&type=template&id=1216207a&"
import script from "./JsmRecaptcha.vue?vue&type=script&lang=js&"
export * from "./JsmRecaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports